module.exports = __webpack_public_path__ + "static/media/emptySuppressionList.fb912ebd.png";